import { createFeatureSelector, createSelector } from "@ngrx/store";
import { SharedState } from "./shared.state";

export const SHARED_STATE_NAME = 'shared';

const getSharedState = createFeatureSelector<SharedState>(SHARED_STATE_NAME);

export const loadingStatus = createSelector(getSharedState, (state) => state.loading);
export const enquiryId = createSelector(getSharedState, (state) => {
    return state.enquiry_id;
});

export const getPreQuote = createSelector(getSharedState, (state) => {
    return state.quote_data;
});

export const getContactDetails = createSelector(getSharedState, (state) => {
    return state.quote_data.contact_details;
});

export const allApiStatus = createSelector(getSharedState, (state) => {
    return state.all_api_response_status;
});

export const updatePreQuoteApiStatus = createSelector(getSharedState, (state) => {
    return state.all_api_response_status.update_pre_quote_data;
});

export const selectPremiumApiStatus = createSelector(getSharedState, (state) => {
    return state.all_api_response_status.select_premium;
})

export const proposalData = createSelector(getSharedState, (state) => {
    return state.proposal_data;
});

export const getPreQuoteDataStatus = createSelector(getSharedState, (state) => {
    return state.all_api_response_status.get_pre_quote_data;
});